import React, { useState, useEffect } from "react";
import { Switch } from "react-router-dom/cjs/react-router-dom.min";
import { AppMenu } from "./AppMenu";
import AppTopBar from "./AppTopBar";
import classNames from "classnames";
import { ConfirmPopup } from "primereact/confirmpopup";
import { ConfirmDialog } from "primereact/confirmdialog";
import "./assets/layout/layout.scss";
import { menuItems } from "./constants/Sidebar";
import ProtectedRoute from "./routes/ProtectedRoute";
import { socket } from "./socket";
import { useSelector, useDispatch } from "react-redux";
import { getLocations } from "./redux/actions/locationAction";
import Loader from "./shared/Loader";

import { getMyId, getMyRole } from "./services/auth";

function App() {
  let { allLocations } = useSelector((state) => state.locations);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getLocations());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const [mobileMenuActive, setMobileMenuActive] = useState(false);

  const wrapperClass = classNames("layout-wrapper", {
    "layout-overlay": !isSidebarOpen,
    "layout-static": isSidebarOpen,
    "layout-mobile-sidebar-active": mobileMenuActive,
  });

  useEffect(() => {
    if (!isDesktop()) {
      setIsSidebarOpen(false);
    }
  }, []);

  const toggleSidebar = () => {
    if (isDesktop()) {
      setIsSidebarOpen((prev) => !prev);
    } else {
      if (isSidebarOpen) {
        setIsSidebarOpen(false);
        setMobileMenuActive(false);
        addClass(document.body, "body-overflow-hidden");
      } else {
        setIsSidebarOpen(true);
        setMobileMenuActive(true);
        removeClass(document.body, "body-overflow-hidden");
      }
    }
  };
  const addClass = (element, className) => {
    if (element.classList) element.classList.add(className);
    else element.className += " " + className;
  };
  const removeClass = (element, className) => {
    if (element.classList) element.classList.remove(className);
    else
      element.className = element.className.replace(
        new RegExp(
          "(^|\\b)" + className.split(" ").join("|") + "(\\b|$)",
          "gi",
        ),
        " ",
      );
  };
  const isDesktop = () => {
    return window.innerWidth >= 992;
  };

  useEffect(() => {
    if (!socket.connected) {
      socket.connect();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [socket.connected]);

  useEffect(() => {
    socket.on("connect", () => socket.emit("join", { userId: getMyId() }));
    socket.on("join", (e) => console.log("joined==>", e));
    socket.on("disconnect", () => console.log("disconnected"));
    return () => {
      socket.off("join");
      socket.off("connect");
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [socket.connected]);

  useEffect(() => {
    if (socket.connected) {
      socket.emit("join", { userId: getMyId() });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [socket.connected]);

  return (
    <div className={wrapperClass}>
      <AppTopBar toggle={toggleSidebar} socket={socket} />
      <div className="layout-sidebar">
        <AppMenu model={menuItems(allLocations, getMyRole())} />
      </div>
      <div className="layout-main-container">
        <div className="layout-main">
          <Loader />
          <ConfirmPopup />
          <ConfirmDialog />
          <Switch>
            <ProtectedRoute socket={socket} />
          </Switch>
        </div>
      </div>
    </div>
  );
}

export default App;
